import { SCIENT_COLORS } from "../../../../../styled/scientColors"
import { Side } from "../types/common"

type SideStyle = {
  backgroundColor: string
  color: string
  fontWeight: "bold"
}

export const getOrderSideStyle = (side?: Side): SideStyle | undefined => {
  switch (side) {
    case Side.BUY:
    case Side.BUY_COVER:
      return {
        backgroundColor: SCIENT_COLORS.green3,
        color: SCIENT_COLORS.white,
        fontWeight: "bold",
      }
    case Side.SELL:
    case Side.SELL_SHORT:
      return {
        backgroundColor: SCIENT_COLORS.gold3,
        color: SCIENT_COLORS.white,
        fontWeight: "bold",
      }
    default:
      return undefined
  }
}

export const getOrderSideBackgroundColor = (side?: Side): string | undefined => {
  return getOrderSideStyle(side)?.backgroundColor
}

export const getOrderSideTextColor = (side?: Side): string | undefined => {
  return getOrderSideStyle(side)?.color
}

// Helper to convert display values (e.g., "Buy", "Sell Short") into Side enum when needed
export const normalizeToSide = (value: string | undefined): Side | undefined => {
  if (!value) return undefined
  const normalized = value.toLowerCase().replace(/\s+/g, "_")
  switch (normalized) {
    case "buy":
      return Side.BUY
    case "buy_cover":
      return Side.BUY_COVER
    case "sell":
      return Side.SELL
    case "sell_short":
      return Side.SELL_SHORT
    default:
      return undefined
  }
}
